import cx from 'classnames';

import { CustomLink } from 'src/components/CustomLink';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import type { BackendOAuthConsentClient } from 'src/types/backend';

import styles from './ClientHeader.module.scss';
import { ClientLogo } from './ClientLogo';

interface ClientHeaderProps {
  className?: string;
  client: BackendOAuthConsentClient;
  redirectHost: string;
}

export const ClientHeader = ({ className, client, redirectHost }: ClientHeaderProps) => (
  <header className={cx(styles.root, className)}>
    <ClientLogo client={client} />

    <CustomTypography
      variant={TYPOGRAPHY_VARIANT.h5}
      component="h1"
      data-testid="oauthConsentClientName"
    >
      {client.name}
      {client.host && <span className={styles.host}> · {client.host}</span>}
    </CustomTypography>

    <CustomTypography variant={TYPOGRAPHY_VARIANT.regular14}>
      wants to connect to your Anyword account.
    </CustomTypography>

    <CustomTypography
      className={styles.muted}
      variant={TYPOGRAPHY_VARIANT.regular12}
      data-testid="oauthConsentRedirectHost"
    >
      After you decide, your browser returns to {redirectHost}.
    </CustomTypography>

    {client.uri && (
      <CustomLink
        className={styles.link}
        href={client.uri}
        target="_blank"
        rel="noopener noreferrer"
        invertUnderline
        data-testid="oauthConsentClientLink"
      >
        {client.uri}
      </CustomLink>
    )}
  </header>
);
